/*
  Cart drawer extras
  - <cart-drawer-recommendations> pulls Shopify product recommendations for the
    most recently added cart item and injects them into the drawer.
  - "+ Add" adds a recommended variant without leaving the drawer, then re-renders
    the drawer and cart bubble the same way Dawn's own cart code does.

  The element lives inside .drawer__inner, which Dawn replaces wholesale on every
  cart change, so connectedCallback re-runs and the list re-seeds itself.
*/
(function () {
  class CartDrawerRecommendations extends HTMLElement {
    connectedCallback() {
      const productId = this.dataset.productId;
      const url = this.dataset.url;

      if (!productId || !url) {
        this.hidden = true;
        return;
      }

      fetch(`${url}&product_id=${productId}`)
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((text) => {
          const block = new DOMParser().parseFromString(text, 'text/html').querySelector('.cd-recs');
          if (!block) {
            this.hidden = true;
            return;
          }
          this.innerHTML = block.outerHTML;
          this.hidden = false;
        })
        .catch(() => {
          this.hidden = true;
        });
    }
  }

  if (!customElements.get('cart-drawer-recommendations')) {
    customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
  }

  function renderSections(sections) {
    if (!sections) return;
    const parser = new DOMParser();

    if (sections['cart-drawer']) {
      const fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
      const target = document.querySelector('.drawer__inner');
      if (fresh && target) target.innerHTML = fresh.innerHTML;

      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
    }

    if (sections['cart-icon-bubble']) {
      const fresh = parser
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    }
  }

  async function addRecommendation(button) {
    const card = button.closest('.cd-recs__card');
    const select = card ? card.querySelector('.cd-recs__variant') : null;
    const variantId = select ? select.value : button.dataset.variantId;
    if (!variantId) return;

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message || 'Add to cart failed');

      renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      console.error('[cart-drawer-extras]', error);
    }
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('.cd-recs__add');
    if (addButton) {
      event.preventDefault();
      addRecommendation(addButton);
      return;
    }

    const arrow = event.target.closest('.cd-recs__arrow');
    if (arrow) {
      event.preventDefault();
      const list = arrow.closest('.cd-recs').querySelector('.cd-recs__list');
      if (list) list.scrollBy({ left: list.clientWidth * Number(arrow.dataset.dir), behavior: 'smooth' });
    }
  });
})();
